import { RawBffConfig } from "@omni/schemas/config/bffConfig.schema";
import { RawContractsConfig } from "@omni/schemas/config/contractsConfig.schema";
import { RawSsrConfig } from "@omni/schemas/config/ssrConfig.schema";
import { ConfigType } from "@omni/types/enums/configType.enum";
import { DeepPartial } from "@omni/types/utils/deepPartial";

import { RawConfigTypes } from "./types/rawConfigTypes.type";

const providers: {
    [P in ConfigType]: () => DeepPartial<RawConfigTypes[P]>;
} = {
    [ConfigType.Components]: () => {
        throw new Error("ConfigProvider for ConfigType=Components was not set");
    },
    [ConfigType.Ssr]: () => process.env as unknown as DeepPartial<RawSsrConfig>,
    [ConfigType.Bff]: () => process.env as unknown as DeepPartial<RawBffConfig>,
    [ConfigType.Contracts]: () =>
        process.env as unknown as DeepPartial<RawContractsConfig>
};

export const getProvider = <TConfigType extends ConfigType>(
    type: TConfigType
): (() => DeepPartial<RawConfigTypes[TConfigType]>) => {
    return providers[type];
};

export const setProvider = <TConfigType extends ConfigType>(
    type: TConfigType,
    provider: () => DeepPartial<RawConfigTypes[TConfigType]>
) => {
    (providers as any)[type] = provider;
};
